/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Attachment } from './attachment';

export type GenericApiResponseListAttachmentData = Attachment[] | null;
